module.exports = __webpack_public_path__ + "static/media/dataset_linked_black_24dp.fde6192b.svg";